import { LAST_SEARCH_KEY, SEARCH_HISTORY_LIMIT } from './constants'
import type { SearchHistoryType } from './searchHistory.types'

export const saveTermOnHistory = (searchValue: string) => {
  const searchs: Array<SearchHistoryType> =
    JSON.parse(localStorage.getItem(LAST_SEARCH_KEY)) || []

  const newSearch = { id: Date.now(), text: searchValue }
  const searchsUnique = searchs.filter(search => search.text !== newSearch.text)

  localStorage.setItem(
    LAST_SEARCH_KEY,
    JSON.stringify([
      newSearch,
      ...searchsUnique.splice(0, SEARCH_HISTORY_LIMIT - 1)
    ])
  )
}

export const removeTermOfHistory = (id: number) => {
  const searchs: Array<SearchHistoryType> =
    JSON.parse(localStorage.getItem(LAST_SEARCH_KEY)) || []
  const newSearchs = searchs.filter(search => search.id !== id)
  localStorage.setItem(LAST_SEARCH_KEY, JSON.stringify(newSearchs))
}

export const removeAllTerms = () => {
  localStorage.setItem(LAST_SEARCH_KEY, JSON.stringify([]))
}
